/**
 * Vue mixin for common assessment/feedback screens.
 * @author tc36d
 */

const DEADLINES = 'deadlines'
const GRADES = 'grades'
const BOTH = 'both'

export default {

  methods: {
    isGraded (hasgrade) {
      const hg = (typeof hasgrade !== 'undefined' ? hasgrade.toUpperCase() : 'TBC')
      if (!this.isTbc(hg) && hg !== 'FALSE') {
        // this.gradesPresent = true
        return true
      }
      return false
    },
    isTbc (str) {
      let ret = false
      const grade = (typeof str !== 'undefined' ? str.toUpperCase() : '')
      if (grade == 'TBC') return true
      if (grade == 'TO BE CONFIRMED') return true
      return ret
    },
    inGradesTab (deadline, subAssessments) {
      const wt = this.whichTab(deadline, subAssessments)
      return (wt == GRADES || wt == BOTH)
    },
    inDeadlinesTab (deadline, subAssessments) {
      const wt = this.whichTab(deadline, subAssessments)
      return (wt == DEADLINES || wt == BOTH)
    },
    whichTab (deadline, subAssessments) {
      // ok, the rules are:
      // does the assignment have a grade? right tab
      // does it have no grade BUT submitted? right tab
      // else left tab
      // ALSO if there are sub assessments,
      //      and some are graded but others aren't, both tabs
      let mixedSubAssessments = false
      if (typeof subAssessments !== 'undefined') {
        let graded = 0
        let total = 0
        for (let sa of subAssessments) {
          total++
          const wt = this.whichTab(sa)
          if (wt == GRADES) {
            graded++
          }
        }
        console.log('deadline ' + deadline.id + ' has sub assessments: ' + total + ' in total, graded: ' + graded)
        if (graded != 0 && graded != total) {
          mixedSubAssessments = true
        }
      }
      let inTab = DEADLINES
      if (this.isGraded(deadline.gradehasgrade)) {
        inTab = GRADES
      } else {
        if (this.isSubmitted(deadline)) {
          inTab = GRADES
        }
      }
      if (mixedSubAssessments) {
        inTab = BOTH
      }
      return inTab
    },
    openAssessment (id) {
      this.go('/assessment/details/' + id)
    },
    isOverdue (deadline) {
      // ok - we won't do this
      // if (status == 'overdue' || deadline.duedate < Date.now()) {
      // because it messes with the filtering
      // we will rely solely on the status sent to us from Moodle/GCAT!
      if (deadline.status == 'overdue') {
        return true
      } else {
        return false
      }
    },
    isSubmitted (deadline) {
      if (deadline.status == 'submitted') {
        return true
      } else {
        return false
      }
    },
    isIndividualComponents (deadline) {
      if (deadline.status == 'individual components') {
        return true
      } else {
        return false
      }
    },
    friendlyDueDate (deadline) {
      let duedate = deadline.duedate
      // today, tomorrow, 3 days, 2 weeks, 4 months etc
      if (duedate === '') {
        duedate = 'Due date = TBC'
        return duedate
      } else if (duedate === 0) {
        return '-'
      } else {
        const SEC_IN_DAY = 86400
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        today.setMilliseconds(0)
        const todaySeconds = today.getTime() / 1000
        const daysAway = Math.floor((duedate - todaySeconds) / SEC_IN_DAY)
        if (daysAway < 0) {
          // ONLY display overdue if isOverdue is true (i.e. status from GCAT is 'overdue')!
          if (this.isOverdue(deadline)) {
            return 'Overdue - ' + this.processDueDate(duedate)
          } else {
            return this.processDueDate(duedate)
          }
        } else if (daysAway == 0) {
          return 'Today'
        } else if (daysAway == 1) {
          return 'Tomorrow'
        } else if (daysAway < 7) {
          return daysAway + ' days away'
        // requirements say specify a date, so 'weeks/months' will not be accurate enough
        // } else if (daysAway < 28) {
        //  const weeks = Math.floor(daysAway / 7)
        //  return this.singPlural(weeks, ' week ', ' weeks ') + 'away'
        } else {
          // just use the actual date
          return this.processDueDate(duedate)
        }
      }
    },
    singPlural (num, singular, plural) {
      return num + (num == 1 ? singular : plural)
    },
    processDueDate (duedate) {
      if (duedate === '') {
        duedate = 'Due date = TBC'
        return duedate
      } else if (duedate === 0) { // likely individual components
        return '-'
      } else {
        return this.formatLongDateForAF(duedate)
      }
    },
    processDueTime (duedate) {
      if (duedate === '') {
        duedate = 'Due date = TBC'
        return duedate
      } else if (duedate === 0) {
        return ''
      } else {
        return this.formatTime(duedate)
      }
    },
    colourFor (deadline) {
      // include the whole deadline/grade in case we need something other
      // than the status to determine the colour
      const st = deadline.status
      let ret = ''
      switch (st) {
        case 'submission not open': ret = 's_notopen'; break
        case 'submit': ret = 's_submit'; break
        case 'overdue': ret = 's_overdue'; break
        case 'not submitted': ret = 's_notsubmitted'; break
        case 'submitted': ret = 's_submitted'; break
        case 'graded': ret = 's_graded'; break
        default:
      }
      return ret
    }
  }
}
